import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type StateType = {
  isDictationOn: boolean;
  transcript: string | null;
  tempTranscript: string | null;
};

const initialState: StateType = {
  isDictationOn: false,
  transcript: null,
  tempTranscript: null,
};

const searchWidgetDictation = createSlice({
  name: 'searchWidgetDictation',
  initialState,
  reducers: {
    startDictation: (state) => {
      return state;
    },
    stopDictation: (state) => {
      return state;
    },
    setDictationState: (state, action: PayloadAction<boolean>) => {
      return { ...state, isDictationOn: action.payload };
    },
    setTempTranscript: (state, action: PayloadAction<string>) => {
      if (state.tempTranscript == null)
        return { ...state, tempTranscript: action.payload };
      return {
        ...state,
        tempTranscript: `${state.tempTranscript} ${action.payload}`,
      };
    },
    setTranscript: (state, action: PayloadAction<string>) => {
      if (state.transcript == null)
        return { ...state, transcript: action.payload };
      return {
        ...state,
        transcript: `${state.transcript} ${action.payload}`,
      };
    },
    resetTempTranscript: (state) => {
      return { ...state, tempTranscript: null };
    },
    resetTranscript: (state) => {
      return { ...state, transcript: null };
    },
  },
});

export const {
  startDictation,
  stopDictation,
  setDictationState,
  setTranscript,
  setTempTranscript,
  resetTempTranscript,
  resetTranscript,
} = searchWidgetDictation.actions;

export default searchWidgetDictation.reducer;
